import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { useEffect, useState } from "react";

import ViewAgendaOutlined from "@mui/icons-material/ViewAgendaOutlined";

import isNil from "lodash/isNil";

import { useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Flx from "../../../../components/layout/Flx";
import TitledHeader from "../../../../components/layout/TitledHeader";
import ToggleTabSwitcher from "../../../../components/navigation/ToggleTabSwitcher";
import TitledCard from "../../../../components/ui/TitledCard";
import { loanDrilldownSidebarTypes } from "../../../../constants/enums/loanDrilldownScreenSidebarOptions";
import { useLoanTermsHook } from "../../../../hooks/useLoanTermsHook";
import { sidebarOpen } from "../../../../redux/reducers/sidebarReducer";
import TemplateSelector from "./components/TemplateSelector";
import { loanFetchedDataEmailTemplatesSet } from "../../../../redux/reducers/loanFetchedDataReducer";
import Screen from "../../../../components/layout/Screen";

const LOAN_INFO_TAB_TYPES = {
  COMPOSER: "Email Templates",
  // SENT: "Sent",
};

// // Extract all {Variable} tokens from a template string
// const extractTemplateVariables = (str = "") => {
//   const regex = /\{([^}]+)\}/g;
//   const vars = new Set();
//   let match;
//   while ((match = regex.exec(str)) !== null) {
//     // Skip conditional syntax like {if:...} {end_if}
//     const token = match[1];
//     if (!token.startsWith("if:") && token !== "end_if") {
//       vars.add(token);
//     }
//   }
//   return Array.from(vars);
// };

// // Replace {Variable} tokens with user-supplied values
// const resolveTemplateVariables = (str = "", values = {}) => {
//   return str.replace(/\{([^}]+)\}/g, (match, token) => {
//     if (token.startsWith("if:") || token === "end_if") return match;
//     return values[token] !== undefined ? values[token] : match;
//   });
// };

const LoanDrilldownCommunicationTab = () => {
  const templateData = useSelector((state) => state.sidebar?.state);
  const emailTemplates = useSelector(
    (state) => state.loanFetchedData?.emailTemplates,
  );

  const { getEmailTemplateNames } = useLoanTermsHook();
  const theme = useTheme();
  const dispatch = useDispatch();
  // const [templates, setTemplates] = useState(null);
  const [tab, setTab] = useState(LOAN_INFO_TAB_TYPES.COMPOSER);

  // const activeTemplate = useMemo(() => {
  //   if (!communicationType) return null;
  //   return find(templates, (t) => t.slug === communicationType) || null;
  // }, [communicationType, templates]);

  const handleSelectTemplate = (template) => {
    if (!template) return;
    dispatch(
      sidebarOpen(
        loanDrilldownSidebarTypes.EMAIL_COMPOSER,
        { ...template },
        {},
      ),
    );
    // navigate(
    //   `/loan/${loanDrilldown?.loanNumber}/communication/${template.slug}`,
    // );
  };

  /**
   * Example return
   * {
        "templateNames": [
          "insurance_request",
          "insurance_quote_request",
          "title_request",
          "title_order_request"
          ]
      }
   */

  useEffect(() => {
    if (isNil(emailTemplates)) {
      getEmailTemplateNames({
        onSuccessFn: (d) => {
          const TEMP_NAME_MAP = {
            insurance_request: "Send Homeowners Insurance Request",
            insurance_quote_request: "Send Insurance Quote Request",
            title_request: "Send Title Request",
            title_order_request: "Send Title Order Request",
          };
          const templateList = d?.templateNames || d;
          const convertedToForm = templateList?.map((n) => {
            return {
              template_display_name: TEMP_NAME_MAP[n], // Custom display name for displaying in table of templates
              name: n, // actual template name used for API calls
            };
          });
          dispatch(loanFetchedDataEmailTemplatesSet(convertedToForm));
        },
      });
    }
  }, []);

  return (
    <Screen sx={{ p: 2 }}>
      <Container maxWidth="md">
        <Flx gap={2}>
          <TitledCard
            sx={{ flexShrink: 0, flexBasis: "500px" }}
            title={"Select Email Template"}
            icon={<ViewAgendaOutlined />}
          >
            <TemplateSelector
              templates={emailTemplates}
              // activeTemplate={activeTemplate}
              activeRowKeyValue={templateData?.name}
              onSelect={handleSelectTemplate}
              allowSearch
            />
          </TitledCard>
        </Flx>
      </Container>
    </Screen>
  );
  return (
    <>
      <TitledHeader
        title={"Loan Communication"}
        sx={{ borderBottom: `1px solid ${theme.palette.divider}`, pb: 0.5 }}
      >
        <ToggleTabSwitcher
          value={tab}
          onChange={setTab}
          sx={{ mt: 1 }}
          tabs={Object.values(LOAN_INFO_TAB_TYPES)}
        />
      </TitledHeader>
      <Box sx={{ py: 2 }}>
        <Container maxWidth="md">
          <Flx gap={2}>
            <TitledCard
              sx={{ flexShrink: 0, flexBasis: "500px" }}
              title={"Select Email Template"}
              icon={<ViewAgendaOutlined />}
            >
              <TemplateSelector
                templates={emailTemplates}
                // activeTemplate={activeTemplate}
                activeRowKeyValue={templateData?.name}
                onSelect={handleSelectTemplate}
                allowSearch
              />
            </TitledCard>
          </Flx>
        </Container>

        {/* <Container maxWidth="lg">
          <Flx gap={2}>
            <TitledCard
              sx={{ flexShrink: 0, flexBasis: "500px" }}
              title={"Select Email Template"}
              icon={<ViewAgendaOutlined />}
            >
              <TemplateSelector
                templates={emailTemplates}
                // activeTemplate={activeTemplate}
                activeRowKeyValue={templateData?.name}
                onSelect={handleSelectTemplate}
                allowSearch
              />
            </TitledCard>
            <EmailPreview
              to={EX_SENT_PAYLOAD.toRecipients}
              subject={EX_SENT_PAYLOAD.subject}
              body={EX_SENT_PAYLOAD.body}
              sentDate={EX_SENT_PAYLOAD.sentDate}
            />
          </Flx>
        </Container> */}
      </Box>
    </>
  );
};

export default LoanDrilldownCommunicationTab;
